import React, { useState } from "react"
import LocalizedLink from "./localizedLink"
import locales from "../../config/i18n"
import { LocaleContext } from "./layout"
import { Link } from "gatsby"

import Image from "./image"

import { css } from "@emotion/core"
import { colors } from "../styles/styles"

export default function LangSwitcher() {
  let { locale, location } = React.useContext(LocaleContext)
  const [isOpenLangSelect, setIsOpenLangSelect] = useState(false)

  return (
    <div className="dropdown dropdown__lang is-active" css={langSwitcherCss}>
      <div className="dropdown-trigger">
        <button
          className="activeLang button is-rounded"
          aria-controls="dropdown-menu"
          onClick={() => setIsOpenLangSelect(!isOpenLangSelect)}
        >
          <img
            src={`../images/flag-${locales[locale].locale}.svg`}
            alt={locales[locale].langName}
            className="flag"
          />
          <span>{locales[locale].langName}</span>
          <i className="icon is-small icon-chevron_down" />
        </button>
      </div>
      {isOpenLangSelect && (
        <div className="allLang dropdown-menu" id="dropdown-menu" role="menu">
          <div className="dropdown-content">
            {Object.keys(locales)
              .filter(lang => locales[lang].locale !== locales[locale].locale)
              .map(lang => {
                const localizedPath = locales[lang].default
                  ? `/`
                  : `/${locales[lang].path}/`
                return (
                  <div key={locales[lang].path} className={locales[lang].path}>
                    <Link
                      key={lang}
                      to={localizedPath}
                      className="dropdown-item"
                      onClick={() =>
                        setIsOpenLangSelect((isOpenLangSelect = false))
                      }
                    >
                      <img
                        src={`../images/flag-${locales[lang].locale}.svg`}
                        alt={locales[lang].langName}
                        className="flag"
                      />
                      {locales[lang].langName}
                    </Link>
                  </div>
                )
              })}
          </div>
        </div>
      )}
    </div>
  )
  return
}

const langSwitcherCss = css`
  .button {
    border: 0;
    background-color: ${colors.blueLang};
    padding-left: 10px;
    padding-right: 40px;
  }

  .icon {
    padding-left: 5em;
  }

  .flag {
    width: 27px;
    margin-right: 10px;
  }

  .dropdown-item {
    display: flex;
    align-items: center;
  }
`
